import { type ProblemDetail } from './problemDetails';
import {
  Conflict,
  ForbiddenError,
  isSbAxiosError,
  NotFoundError,
  type SbError,
  ValidationError,
} from './sbError';
import { type ErrorHandlerOptions } from './types';

export const defaultMessage = 'Er is een onverwachte fout opgetreden.';
export const defaultSolution =
  '<a href="/net/home/about" target="_blank">Neem contact op</a> met een van onze medewerkers of probeer het later opnieuw.';
export const vermelding = (correlationId: string) =>
  `<br /><br />Vermeld altijd dit kenmerk: <p class='font-mono'>${correlationId}</p>`;

export function createErrorMessage(error: Error | null | SbError, options?: ErrorHandlerOptions) {
  if (isSbAxiosError(error)) {
    const { correlationId } = error.sbError;
    if (error.sbError instanceof NotFoundError && options?.onNotFoundError) {
      return options.onNotFoundError;
    }
    if (error.sbError instanceof ValidationError && options?.onValidationError) {
      return options.onValidationError;
    }
    if (error.sbError instanceof ForbiddenError && options?.onForbiddenError) {
      return options?.onForbiddenError;
    }
    if (error.sbError instanceof Conflict && options?.onConflictError) {
      return options?.onConflictError;
    }
    return `${options?.defaultMessage ?? defaultMessage} ${options?.defaultSolution ?? defaultSolution}${
      correlationId ? vermelding(correlationId) : ''
    }`;
  }

  return `${options?.defaultMessage ?? defaultMessage} ${options?.defaultSolution ?? defaultSolution}`;
}

export const convertExternalValidations = (
  detail: ProblemDetail,
  keyToLowercase = true,
): Record<string, string> =>
  Object.entries(detail).reduce(
    (record, [key, value]) => {
      if (Array.isArray(value)) {
        if (keyToLowercase) {
          record[key.toLowerCase()] = value.join(' ');
        } else {
          record[key] = value.join(' ');
        }
      }

      return record;
    },
    {} as Record<string, string>,
  );

export const prefixProblemDetailKeys = (detail: ProblemDetail, prefix: string): ProblemDetail =>
  Object.entries(detail).reduce((record, [key, value]) => {
    record[`${prefix}.${key.toLowerCase()}`] = value;
    return record;
  }, {} as ProblemDetail);
